import React from "react";
import { LanguageMenu } from "./Language";
import { NavLink } from "react-router-dom";
import t from "../i18n";
import { CatalogService } from "../services/catalog-service";

declare type MobileMenuProps = {
    isLoggedIn: boolean;
    getUserName: () => string;
    onLogin: () => void;
    onRegister: () => void;
    onLogout: () => void;
    showDashboard: boolean;
}
declare type MobileMenuState = {
    showMenu: boolean;
}
export default class MobileMenu extends React.Component<MobileMenuProps, MobileMenuState> {
    readonly state: MobileMenuState = { showMenu: false };
    openMenu = () => {
        document.body.classList.add("scrollbar-hider");
        this.setState({ showMenu: true });
    }
    closeMenu = () => {
        document.body.classList.remove("scrollbar-hider");
        this.setState({ showMenu: false });
    }
    toggleMenu = () => {
        if (this.state.showMenu) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }
    render() {
        const showDashboard = this.props.showDashboard;
        return (
            <React.Fragment>
                {showDashboard && this.renderMenu()}
                {!showDashboard && this.renderStorePinMenu()}
            </React.Fragment>
        )
    }
    renderMenu() {
        const menuText = this.state.showMenu ? t.common("close") : t.common("menu");
        const isLoggedIn = this.props.isLoggedIn;
        return <div className="d-flex d-md-none text-right">
            <div className="menu-trigger" onClick={this.toggleMenu}>
                <span style={{ marginRight: 5 }}>{menuText}</span>
                <i style={{ fontSize: 20 }} className="fa fa-bars" />
            </div>
            {this.state.showMenu && <ul id="menu" className="text-left mobile-menu">
                {this.props.isLoggedIn &&
                    <li>
                        <a>
                            <i className="fa fa-user mr-3" style={{ fontSize: 25 }} />
                            <span>{this.props.getUserName()}</span>
                        </a>
                    </li>
                }
                <li>
                    <LanguageMenu textColor="#fff" isMobile={true} onLanguageSelected={this.closeMenu} isLoggedIn={this.props.isLoggedIn} />
                </li>
                <li><NavLink onClick={this.closeMenu} to="/home">{t.menu("dashboard")}</NavLink></li>
                <li><NavLink onClick={this.closeMenu} to="/topup">{t.menu("send_balance")}</NavLink></li>
                {CatalogService.isSiteETO() && <li><a onClick={this.closeMenu} href="/topup#/giftcard">{t.menu("buy_gift_card")}</a></li>}
                {!CatalogService.isSitePosIT() && !CatalogService.isSiteCodesDirect() && <li><NavLink onClick={this.closeMenu} to="/auto-topups">{t.menu("auto_balance")}</NavLink></li>}

                {isLoggedIn && <React.Fragment>
                    <li><NavLink onClick={this.closeMenu} to="/order-history">{t.menu("order_history")}</NavLink></li>
                    <li><NavLink onClick={this.closeMenu} to="/reward-points">{t.menu("reward_points")}</NavLink></li>
                    <li><NavLink onClick={this.closeMenu} to="/tickets">{t.menu("support")}</NavLink></li>
                    <li><NavLink onClick={this.closeMenu} to="/contact-list">{t.menu("contact_list")}</NavLink></li>
                    <li><NavLink onClick={this.closeMenu} to="/change-password">{t.menu("change_password")}</NavLink></li>
                    {/* <li><NavLink onClick={this.closeMenu} to="/manage-payments">{t.menu("manage-payments")}</NavLink></li> */}
                </React.Fragment>}

                {!isLoggedIn && <li><a href="javascript:void(0)" onClick={this.props.onLogin}>{t.menu("login")}</a></li>}
                {!isLoggedIn && <li><a href="javascript:void(0)" onClick={this.props.onRegister}>{t.menu("register")}</a></li>}
                {isLoggedIn && <li><a href="javascript:void(0)" onClick={this.props.onLogout}>{t.menu("logout")}</a></li>}
                <li style={{ flex: 1, opacity: 1, borderTop: "1px solid #f2f2f2" }} />
            </ul>}
        </div>

    }

    renderStorePinMenu() {
        const menuText = this.state.showMenu ? t.common("close") : t.common("menu");
        return <div className="d-flex d-md-none text-right">
            <div className="menu-trigger" onClick={this.toggleMenu}>
                <span style={{ marginRight: 5 }}>{menuText}</span>
                <i style={{ fontSize: 20 }} className="fa fa-bars" />
            </div>
            {this.state.showMenu && <ul id="menu" className="text-left mobile-menu">
                <li>
                    <LanguageMenu textColor="#fff" isMobile={true} onLanguageSelected={this.closeMenu} isLoggedIn={this.props.isLoggedIn} />
                </li>
                <li><NavLink onClick={this.closeMenu} to="/topup">{t.menu("send_balance")}</NavLink></li>
                <li style={{ flex: 1, opacity: 1, borderTop: "1px solid #f2f2f2" }} />
            </ul>}
        </div>
    }
}